export default __webpack_public_path__ + "static/media/pexels-brett-jordan-6140527.3450ed49.jpg";